import { useQuery } from '@tanstack/react-query'
import { useRouter } from 'next/router'

import { getHeaderData } from '@/lib/cms/getHeaderData'
import useGlobalStore from '@/store/useGlobalStore'

export const useHeaderQuery = () => {
  const router = useRouter()

  const {
    app: { locale },
  } = useGlobalStore()

  return useQuery({
    queryKey: ['header', 'persisted', locale],
    queryFn: async () => {
      const result = await getHeaderData({
        locale,
      })

      if (!result) {
        throw new Error('Hea der data not available')
      }

      if ('error' in result) {
        throw new Error(result.error.message)
      }

      return result
    },
    enabled: Boolean(router.query.alpha3 && router.query.language),
    gcTime: 30 * 60 * 1000, // 30 minutes
    retry: 3,
    retryDelay: (attemptIndex: number) =>
      Math.min(1000 * 2 ** attemptIndex, 30_000),
    placeholderData: (previousData) => previousData, // Keep previous data while loading
    notifyOnChangeProps: ['data', 'error'], // Only trigger re-renders when data or error changes
  })
}
